import React from 'react';

const KeyValue = (props) => {
  const { title, value, fontSize } = props;

  return (
    <div className="key-value" style={{ fontSize: fontSize ? fontSize : '2.25vw' }}>
      <div style={{ textTransform: 'uppercase' }}>{title}</div>
      <div style={{ fontWeight: 'bold' }}>{value}</div>
    </div>
  );

};

export default KeyValue;